<div class="confirm-modal {{ type }}">
  <img [src]="image" alt="icon" class="confirm-modal__icon" />
  <div class="content">
    <h5>{{ title }}</h5>
    <p>{{ description }}</p>
  </div>
  <img
    (click)="close()"
    (keypress)="true"
    [src]="closeIcon"
    alt="close"
    class="confirm-modal__close"
  />
</div>
